<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import { computed } from 'vue';
    import { ProtocolFormPointMap, ProtocolFormStateSection } from './coachingForm.types';
    import { useSectionColor } from '@/js/composables/useSectionColor';
    import { ChevronDownIcon } from '@lucide/vue';

    const props = defineProps<{
        section: ProtocolFormStateSection;
        points: ProtocolFormPointMap[string];
        sectionIndex: number;
    }>();

    const { getCardAccentColor } = useSectionColor();

    const percentage = computed(() => {
        const sectionPoints = props.points;
        if (!sectionPoints || sectionPoints.maxPoints === 0) {
            return 0;
        }
        return Number((sectionPoints.points / sectionPoints.maxPoints) * 100).toFixed(0);
    });
</script>
<template>
    <div class="flex justify-between items-center px-5 w-full py-4 bg-white hover:bg-gray-lightest">
        <h3 class="heading-md flex items-center gap-2">
            <span
                class="w-2 h-7.5 rounded-full shrink-0"
                :class="getCardAccentColor(sectionIndex)"
            />
            <ChevronDownIcon
                class="size-5 shrink-0 text-gray-medium -rotate-90 transition-transform duration-150 group-open:rotate-0"
            />
            {{ section.title }}
        </h3>
        <div class="flex items-center gap-4">
            <p class="text-body text-gray-medium">
                {{ __('coaching-form-total-points') }}
            </p>
            <div class="flex gap-2 px-3 py-1 border-gray-light border rounded-full">
                <p class="text-body-bold text-center whitespace-nowrap">
                    {{ points.points }}
                    {{ __('coaching-form-points-of') }}
                    {{ points.maxPoints }}
                </p>
                <div class="w-0 border-gray-light border-r" />
                <p class="text-body-bold text-center whitespace-nowrap">{{ percentage }}%</p>
            </div>
        </div>
    </div>
</template>
